import GraffitiInfestation from './graffiti-infestation';

export default GraffitiInfestation;